import { BASE_URL } from "@/config";
import axios from "axios";
import { disconnectTaxiSocket } from "@/hooks/useTaxiSocket";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error),
);

const logout = () => {
  console.log("Token revoked - performing cleanup before redirect");

  // Disconnect websocket
  disconnectTaxiSocket();

  // Clear tokens
  localStorage.removeItem("access_token");
  localStorage.removeItem("permissions");

  // Redirect to login
  window.location.href = "/login";
};

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.message;

    if (status === 401 && message === "Token has been revoked") {
      logout();
      return Promise.reject(new Error("Session expired. Logging out..."));
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
